import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { useTable, useFilters, useGlobalFilter, useSortBy } from "react-table";
import matchSorter from 'match-sorter'


const GlobalFilter = ({ preGlobalFilteredRows,
  globalFilter,
  setGlobalFilter }) => {
  const count = preGlobalFilteredRows.length;
  return (
    <span>
      {" "}
      <input
        value={globalFilter || ""}
        onChange={e => {
          setGlobalFilter(e.target.value || undefined); // Set undefined to remove the filter entirely
        }}
        placeholder={`${count} records...`}
        style={{
          fontSize: "1.1rem",
          border: "0"
        }}
      />
      <div className="search-clear">
        <button onClick={() => setGlobalFilter(undefined)}><i className="fas fa-times-circle fa-2x"></i></button>
      </div>
    </span>
  );
}

function DefaultColumnFilter({
  column: { filterValue, preFilteredRows, setFilter },
}) {
  const count = preFilteredRows.length
  return (
    <input
      value={filterValue || ''}
      onChange={e => {
        setFilter(e.target.value || undefined) // Set undefined to remove the filter entirely
      }}
      placeholder={`Search ${count} records...`}
    />
  )
}

function fuzzyTextFilterFn(rows, id, filterValue) {
  return matchSorter(rows, filterValue, { keys: [row => row.values[id]] })
}

function renderSortArrows(column) {
  if (column.canSort && column.isSorted) {
    return column.isSortedDesc
      ? <i className="fas fa-sort-up"></i>
      : <i className="fas fa-sort-down"></i>
  }
  return <i className="fas fa-sort"></i>
}

fuzzyTextFilterFn.autoRemove = val => !val

const AdminTableComponent = ({ columns, data }) => {
  const filterTypes = React.useMemo(
    () => ({
      // Add a new fuzzyTextFilterFn filter type.
      fuzzyText: fuzzyTextFilterFn,
      // Or, override the default text filter to use
      // "startWith"
      text: (rows, id, filterValue) => {
        return rows.filter(row => {
          const rowValue = row.values[id]
          return rowValue !== undefined
            ? String(rowValue)
              .toLowerCase()
              .startsWith(String(filterValue).toLowerCase())
            : true
        })
      },
    }),
    []
  )
  const defaultColumn = React.useMemo(
    () => ({
      // Let's set up our default Filter UI
      Filter: DefaultColumnFilter,
    }),
    []
  )
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    state,
    visibleColumns,
    preGlobalFilteredRows,
    setGlobalFilter,
  } = useTable({
    columns,
    data,
    defaultColumn,
    filterTypes
  },
    useFilters,
    useGlobalFilter,
    useSortBy
  );

  return (
    <span>
      <div className="admin-search"
        colSpan={visibleColumns.length}
        style={{
          textAlign: 'right',
        }}
      >
        <GlobalFilter
          preGlobalFilteredRows={preGlobalFilteredRows}
          globalFilter={state.globalFilter}
          setGlobalFilter={setGlobalFilter}
        />
      </div>
      <div className="table-responsive admin-table">
        <table {...getTableProps()}>
          <thead>
            <tr>
            </tr>
            {headerGroups.map(headerGroup => (
              <tr className="table-row" {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map(column => (
                  <th className="table-head" {...column.getHeaderProps(column.getSortByToggleProps())}>
                    <span>
                      {column.render("Header")}
                      {/* Add a sort direction indicator */}
                      {renderSortArrows(column)}
                    </span>
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps()}>
            {rows.map((row, i) => {
              prepareRow(row);
              return (
                <tr {...row.getRowProps()}>
                  {row.cells.map(cell => {
                    let renderedCell = null;
                    if (cell.column.CustomData) {
                      renderedCell = cell.render("Cell", { data: row.original });
                    } else {
                      renderedCell = cell.render("Cell");
                    }
                    return <td {...cell.getCellProps()}>{renderedCell}</td>;
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </span>
  );
}
export default withRouter(connect()(AdminTableComponent));
